import styles from './ScrollHandleBar.module.css'
import clsx from 'clsx'
import { BasicStyledComponent } from 'shared-definitions/types'
import { useEffect, useState } from 'react'

interface ScrollHandleBarProps extends BasicStyledComponent {
  all: number
  visible: number
  current: number
}

const ScrollHandleBar: React.VFC<ScrollHandleBarProps> = ({ className, all, visible, current }) => {
  const [left, setLeft] = useState(0)
  const handleWidth = (visible / all) * 100

  useEffect(() => {
    const l = (100 - handleWidth) / (all - visible)
    setLeft(((current * l) / handleWidth) * 100)
  }, [current, handleWidth, all, visible])

  return (
    <div className={clsx(styles.container, className)}>
      <div
        className={styles.handle}
        style={{ width: `${handleWidth}%`, transform: `translateX(${left}%)` }}
      />
    </div>
  )
}

export default ScrollHandleBar
